import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import { getDataAPI } from "../../services/apiWrapper";
import {
  publicIndividualMembers,
  publicOtherMembers,
} from "../../store/actions/printActions/printcategory";
import "../Centers/css/filters.css";

// "Our Members" - built like the public Training Center List (/atc).
// The visitor picks Category -> State -> City and presses Submit; members
// are listed only after that search, never on page load.
// Category "Individual" reads the individual members; every other category
// reads the entity (organisation) members of that category.
export default function OurMembers() {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [search, setSearch] = useState("");
  const [searched, setSearched] = useState(null); // {category, state, city, search} of the last Submit
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const isIndividual = (id) =>
    (categories.find((c) => String(c.id) === String(id))?.name || "")
      .trim()
      .toLowerCase() === "individual";

  const fetchMembers = async (cat, st, ci, p, sr = "") => {
    return isIndividual(cat)
      ? dispatch(publicIndividualMembers(p, sr, st, ci))
      : dispatch(publicOtherMembers(p, sr, st, ci, cat));
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await dispatch(getDataAPI("admin/list/category"));
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        // Individual first, then the entity categories in their saved order
        list.sort((a, b) =>
          (a.name || "").trim().toLowerCase() === "individual"
            ? -1
            : (b.name || "").trim().toLowerCase() === "individual"
            ? 1
            : 0
        );
        setCategories(list);
      } catch (e) {
        setCategories([]);
      }
    })();
  }, [dispatch]);

  // the State list is the states that category's members are in;
  // the City list follows the chosen state
  const loadPlaces = async (cat, st) => {
    const res = await fetchMembers(cat, st, "", 1);
    setStates(res.states || []);
    setCities(st ? res.cities || [] : []);
  };

  const pickCategory = (e) => {
    const v = e.target.value;
    setCategory(v);
    setState("");
    setCity("");
    setStates([]);
    setCities([]);
    if (v) loadPlaces(v, "");
  };

  const pickState = (e) => {
    const v = e.target.value;
    setState(v);
    setCity("");
    setCities([]);
    if (v) loadPlaces(category, v);
  };

  const run = async (cat, st, ci, p, sr = "") => {
    setLoading(true);
    const res = await fetchMembers(cat, st, ci, p, sr);
    setRows(res.data?.data || []);
    setPageCount(res.data?.last_page || 0);
    setLoading(false);
  };

  const submit = (e) => {
    e.preventDefault();
    // Category is required; State/City are optional filters. The free-text
    // Search box is shown only after the list appears (top-right of the list).
    if (!category) return;
    setSearched({ category, state, city, search, individual: isIndividual(category) });
    setPage(1);
    run(category, state, city, 1, search);
  };

  // Search box that sits above the list once results are shown.
  const doSearch = () => {
    if (!searched) return;
    setSearched({ ...searched, search });
    setPage(1);
    run(searched.category, searched.state, searched.city, 1, search);
  };

  const cols = searched?.individual
    ? ["S.No.", "Member Name", "Member Id", "State", "City", "Course", "Training Centre", "Examination Body", "Membership Status"]
    : ["S.No.", "Category", "Sub Category", "Entity Name", "Unique Id", "Contact Name", "State", "City", "Membership Status"];

  const badge = (s) =>
    s === "Active" ? (
      <span className="badge bg-success">Active</span>
    ) : (
      <span className="badge bg-danger">Inactive</span>
    );

  return (
    <div className="topper-student mt-4">
      <div className="container" style={{ borderColor: "#ff0000" }}>
        <div className="page_Tile" style={{ background: "#ff0000" }}>
          <span>Our Members</span>
        </div>
        <div className="row">
          <div className="serach-form">
            <div className="form-list">
              <div className="box_list_main">
                <form className="selectbox" onSubmit={submit}>
                  <div className="boxes" style={{ width: "25%", maxWidth: "none", paddingRight: 15 }}>
                    <label>Category</label>
                    <select className="form-control" value={category} onChange={pickCategory}>
                      <option value="">Select Category</option>
                      {categories.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="boxes" style={{ width: "25%", maxWidth: "none", paddingRight: 15 }}>
                    <label>State</label>
                    <select className="form-control" value={state} onChange={pickState} disabled={!category}>
                      <option value="">Select State</option>
                      {states.map((s, i) => (
                        <option key={i} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="boxes" style={{ width: "25%", maxWidth: "none", paddingRight: 15 }}>
                    <label>City</label>
                    <select
                      className="form-control"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      disabled={!state}
                    >
                      <option value="">Select City</option>
                      {cities.map((c, i) => (
                        <option key={i} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="boxes" style={{ width: "25%", maxWidth: "none", paddingRight: 0 }}>
                    <label>&nbsp;</label>
                    <button
                      className="btn btn-reset"
                      type="submit"
                      disabled={!category}
                      style={{ padding: "10px 34px", height: 42, borderRadius: 43, width: "100%" }}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {category && states.length === 0 && !loading && (
            <p className="text-center w-100 mt-3">No members in this category yet.</p>
          )}

          {!searched ? (
            <p className="text-center w-100 mt-3" style={{ color: "#555" }}>
              Select a Category (State and City are optional), then press Submit to see the members.
            </p>
          ) : (
            <div className="tablelist" style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 12,
                  flexWrap: "wrap",
                }}
              >
                <input
                  type="text"
                  className="form-control"
                  style={{
                    maxWidth: 280,
                    height: 42,
                    border: 0,
                    borderRadius: 4,
                    boxShadow: "0 1px 4px 0 rgb(185 186 187 / 40%)",
                  }}
                  placeholder="Search Name / Member Id / Roll..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      doSearch();
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-reset"
                  style={{ padding: "10px 30px", height: 42, borderRadius: 43 }}
                  onClick={doSearch}
                >
                  Search
                </button>
              </div>
              <div className="bs-example table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      {cols.map((c) => (
                        <th key={c}>{c}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={cols.length} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : rows.length === 0 ? (
                      <tr>
                        <td colSpan={cols.length} className="text-center">
                          No Member Found
                        </td>
                      </tr>
                    ) : searched.individual ? (
                      rows.map((m, i) => (
                        <tr key={i}>
                          <td>{(page - 1) * 12 + i + 1}</td>
                          <td>{m.name || "-"}</td>
                          <td>{m.member_id || "-"}</td>
                          <td>{m.state || "-"}</td>
                          <td>{m.city || "-"}</td>
                          <td>{m.course || "-"}</td>
                          <td>{m.training_centre || "-"}</td>
                          <td>{m.examination_body || "-"}</td>
                          <td>{badge(m.status)}</td>
                        </tr>
                      ))
                    ) : (
                      rows.map((m, i) => (
                        <tr key={i}>
                          <td>{(page - 1) * 12 + i + 1}</td>
                          <td>{m.category || "-"}</td>
                          <td>{m.sub_category || "-"}</td>
                          <td>{m.name || "-"}</td>
                          <td>{m.unique_id || "-"}</td>
                          <td>{m.contact || "-"}</td>
                          <td>{m.state || "-"}</td>
                          <td>{m.city || "-"}</td>
                          <td>{badge(m.status)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {searched && pageCount > 1 && (
          <ReactPaginate
            className="pagination mt-5 justify-content-center"
            previousClassName="page-item"
            nextClassName="page-item"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            nextLinkClassName="page-link"
            previousLinkClassName="page-link"
            activeClassName="active"
            onPageChange={(e) => {
              setPage(e.selected + 1);
              run(searched.category, searched.state, searched.city, e.selected + 1, searched.search);
            }}
            pageCount={pageCount}
            forcePage={page - 1}
          />
        )}
      </div>
    </div>
  );
}
